// data/autoClear.ts
import { getDatabase, ref, get, update, set } from "firebase/database";
import { getServerTime } from "./userService";

export const autoResetJogosMensal = async () => {
  const db = getDatabase();
  const timestamp = await getServerTime();
  const now = new Date(timestamp);
  const mesAtual = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}`;

  try {
    const configRef = ref(db, "config");
    const configSnap = await get(configRef);
    const ultimoReset = configSnap.val()?.ultimoReset;

    if (ultimoReset === mesAtual) return; // já resetou este mês

    const usersSnap = await get(ref(db, "users"));
    const users = usersSnap.val() || {};

    const presencaSnap = await get(ref(db, "presenca"));
    const presenca = presencaSnap.val() || {};

    const updates: { [path: string]: number } = {};

    // se tiver gente inscrita no dia 1, mantém quem estava com totalJogos = 1
    if (Object.keys(presenca).length > 0) {
      Object.keys(users).forEach((uid) => {
        const estaInscrito = Object.keys(presenca).includes(uid);
        const novoTotal = estaInscrito ? 1 : 0;

        updates[`users/${uid}/totalJogos`] = novoTotal;
        if (estaInscrito) {
          updates[`presenca/${uid}/totalJogos`] = novoTotal;
        }
      });
    } else {
      // ninguém se inscreveu no dia 1 ou já passou do dia 1 — zera geral
      Object.keys(users).forEach((uid) => {
        updates[`users/${uid}/totalJogos`] = 0;
        if (Object.keys(presenca).includes(uid)) {
          updates[`presenca/${uid}/totalJogos`] = 0;
        }
      });
    }

    await update(ref(db), updates);
    await set(ref(db, "config/ultimoReset"), mesAtual);

    console.log("✅ Contagem de jogos resetada.");
  } catch (error) {
    console.error("Erro ao resetar jogos:", error);
  }
};
